export default {
    SECONDS_IN_DAY: 86400,
    SECONDS_IN_HOUR: 3600,
};